import * as echarts from "echarts";

export function createChartRegistry() {
  return {
    instances: {},
    clickHandlers: {},
    get(vm, refName, clickHandler) {
      const el = vm.$refs[refName];
      if (!el) {
        return null;
      }

      let chart = this.instances[refName];
      const disposed = chart && typeof chart.isDisposed === "function" && chart.isDisposed();
      if (!chart || disposed) {
        const orphan = echarts.getInstanceByDom(el);
        if (orphan) {
          orphan.dispose();
        }
        chart = echarts.init(el);
        this.instances[refName] = chart;
        this.clickHandlers[refName] = null;
      }

      if (clickHandler && this.clickHandlers[refName] !== clickHandler) {
        if (this.clickHandlers[refName]) {
          chart.off("click", this.clickHandlers[refName]);
        }
        this.clickHandlers[refName] = clickHandler;
        chart.on("click", clickHandler);
      }

      return chart;
    },
    setOption(vm, refName, option, clickHandler) {
      const chart = this.get(vm, refName, clickHandler);
      if (chart) {
        chart.setOption(option, true);
      }
    },
    resize() {
      Object.values(this.instances).forEach((chart) => {
        if (chart) {
          chart.resize();
        }
      });
    },
    dispose() {
      Object.entries(this.instances).forEach(([refName, chart]) => {
        if (!chart) {
          return;
        }
        const handler = this.clickHandlers[refName];
        if (handler) {
          chart.off("click", handler);
        }
        chart.dispose();
      });
      this.instances = {};
      this.clickHandlers = {};
    },
  };
}

export function bindChartResize(vm, registry) {
  vm._chartResizeHandler = () => registry.resize();
  window.addEventListener("resize", vm._chartResizeHandler);
}

export function unbindChartResize(vm) {
  if (vm._chartResizeHandler) {
    window.removeEventListener("resize", vm._chartResizeHandler);
    vm._chartResizeHandler = null;
  }
}
